var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common-seach-wrap"},[(_vm.activeName=='list')?_c('List'):_vm._e(),_vm._v(" "),(_vm.activeName=='receive')?_c('Receive'):_vm._e(),_vm._v(" "),(_vm.activeName=='send')?_c('SendCoupon'):_vm._e(),_vm._v(" "),(_vm.activeName === 'set')?_c('CouponSet'):_vm._e(),_vm._v(" "),(_vm.activeName === 'log')?_c('CouponUsedLog'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8437b658","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/plus/coupon/index.vue
// module id = null
// module chunks = 